<template>
  <div @click="openDialog">
    <div>
      备份关系
    </div>
    <a-modal
      title="机器人互相备份关系"
      @cancel="visible = false"
      :footer="null"
      :visible="visible">
      <a-radio-group :options="plainOptions" :defaultValue="value1" style="margin: 10px 0;"/>
      <div style="text-align: center"><a-spin :spinning="spinning"/></div>
      <div v-for="group in groupList" :key="group.backup_bot_id" class="margin" style="display: flex;">
        <span>{{group.index + '.'}}</span>
        <div
          style="display: inline-flex; flex-direction: column; align-items: center"
          class="margin-left"
          v-for="bot in group.bot_list1"
          :key="bot.username">
          <a-tag
            style="margin-bottom: 15px;"
            color="#2db7f5"
            @click="changeBot(bot.username, group, 'reduce')"
          >{{bot.nickname}}&nbsp;<a-icon type="close"/></a-tag>
          <a-tag @click="checkChange(bot.username, group)">{{bot.username === group.main_bot ? '大王' : '设为大王'}}</a-tag>
        </div>
        <a-dropdown :trigger="['click']" class="margin-left">
          <a-button class="ant-dropdown-link" @click="getDisabled(group)" size="small">添加机器人<a-icon type="down"/></a-button>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="bot in botList"
              :disabled="bot.disabled"
              :key="bot.username">
              <div @click="changeBot(bot.username, group)" class="padding">{{bot.nickname}}</div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-button @click="e => deleteBot(e, group)" size="small" type="danger" class="margin-left">整组删除</a-button>
      </div>
      <div class="margin">
        <span>{{`${groupList.length + 1}.`}}</span>
        <a-dropdown :trigger="['click']" class="margin-left">
          <a-button class="ant-dropdown-link" @click="getDisabled()" size="small">添加机器人<a-icon type="down"/></a-button>
          <a-menu slot="overlay">
            <a-menu-item
              v-for="bot in botList"
              :disabled="bot.disabled"
              :key="bot.username">
              <div @click="changeBot(bot.username)" class="padding">{{bot.nickname}}</div>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <div style="text-align: right">
        <a-button @click="checkAndInvite" type="primary">检测&拉人</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'BackupBots',
  props: {
    clientId: Number,
    botList: Array
  },
  data () {
    return {
      getListUrl: global.DOMAIN + 'uclient/get_backup_bots_info_list', // 获取列表
      getDisabledUrl: global.DOMAIN + 'uclient/get_disabled_backup_bot_list', // 禁用的机器人
      setUrl: global.DOMAIN + 'uclient/set_backup_bots', // 设置列表
      deleteUrl: global.DOMAIN + 'uclient/delete_backup_bots', // 删除列表
      inviteUrl: global.DOMAIN + 'uclient/check_backup_and_invite', // 一键拉人
      visible: false,
      spinning: true,
      flag: 1,
      plainOptions: [
        { label: '平均工作', value: '1', disabled: true },
        { label: '集中工作', value: '2' }
      ],
      value1: '2',
      groupList: [],
      disabledList: []
    }
  },
  methods: {
    openDialog () {
      this.getList()
      this.visible = true
    },
    getList () {
      this.axios.post(this.getListUrl, {
        token: sessionStorage.token,
        client_id: this.clientId
      }).then(res => {
        if (res.data.err_code === 0) {
          this.spinning = false
          this.groupList = res.data.content.backup_bots_info_list
          this.handleList()
        } else {
          this.$message.error(res.data.content.desc)
        }
      })
    },
    handleList () {
      let i = 1
      this.groupList.forEach(item => {
        item.index = i
        item.bot_list1 = []
        i++
        this.botList.forEach(bot => {
          if (item.bot_list.some(x => x === bot.username)) {
            item.bot_list1.push(bot)
          }
        })
      })
    },
    getDisabled (group = { bot_list: [] }) {
      this.axios.post(this.getDisabledUrl, {
        token: sessionStorage.token,
        client_id: this.clientId,
        backup_bot_id: group.backup_bot_id
      }).then(res => {
        if (res.data.err_code === 0) {
          this.disabledList = res.data.content.disabled_backup_bot_list
          this.botList.forEach(item => {
            item.disabled = this.disabledList.some(x => x === item.username) || group.bot_list.some(x => x === item.username)
          })
          this.$forceUpdate()
        } else {
          this.$message.error(`获取禁用机器人列表失败：${res.data.content.desc}`)
        }
      })
    },
    changeBot (value, group, act = 'add') {
      let self = this
      let nickname
      this.botList.forEach(item => {
        if (item.username === value) {
          nickname = item.nickname
        }
      })
      if (!group) {
        group = {
          bot_list: [],
          client_id: this.clientId,
          main_bot: value
        }
      }
      this.$confirm({
        title: '确认',
        content: self.getText(act, group, nickname),
        onOk () {
          if (act === 'add') {
            group.bot_list.push(value)
          } else if (act === 'reduce') {
            group.bot_list.splice(group.bot_list.indexOf(value), 1)
            if (value === group.main_bot) { group.main_bot = group.bot_list[0] }
          } else if (act === 'change') {
            group.main_bot = value
          }
          group.token = sessionStorage.token
          self.axios.post(self.setUrl, group).then(res => {
            if (res.data.err_code === 0) {
              self.getList()
            } else {
              self.$message.error(res.data.content.desc)
            }
          })
        }
      })
    },
    deleteBot (e, group) {
      let self = this
      this.$confirm({
        title: '确认',
        content: `确认删除第${group.index}组？`,
        onOk () {
          self.axios.post(self.deleteUrl, {
            token: sessionStorage.token,
            backup_bot_id: group.backup_bot_id
          }).then(res => {
            if (res.data.err_code === 0) {
              self.$message.success('删除成功')
              self.getList()
            } else {
              self.$message.error(res.data.content.desc)
            }
          })
        }
      })
    },
    getText (act, group, nickname) {
      if (act === 'change') {
        return `是否设置${nickname}为第${group.index}组的大王？`
      } else {
        return act === 'reduce' ? `是否删除第${group.index}组的${nickname}` : `是否添加${nickname}${group ? '至' : '来新建'}第${group.index || 1}组？`
      }
    },
    checkChange (username, group) {
      if (username !== group.main_bot) {
        this.changeBot(username, group, 'change')
      }
    },
    checkAndInvite () {
      let self = this
      this.$confirm({
        title: '检测&拉人',
        content: '确定操作？',
        onOk () {
          self.axios.post(self.inviteUrl, {
            token: sessionStorage.token,
            client_id: self.clientId
          }).then(res => {
            if (res.data.err_code === 0) {
              self.$message.success('操作成功')
            } else {
              self.$message.error(res.data.content.desc)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .margin {
    margin: 20px 0;
  }
  .margin-left {
    margin-left: 10px;
  }
  .ant-dropdown-menu-item {
    padding: 0!important;
  }
  .padding {
    padding: 5px 12px;
  }
</style>
